import React from 'react';
import './ResetZoomButton.scss';
export const ResetZoomButton = ({ currentFactorTimeseriesData, setDetailChartData, masterChartRef, setShowReset, showReset, }) => (React.createElement("button", { className: "reset-zoom-button", type: "button", onClick: () => {
        var _a;
        const xAxis = (_a = masterChartRef.current) === null || _a === void 0 ? void 0 : _a.chart.xAxis[0];
        setDetailChartData(currentFactorTimeseriesData);
        setShowReset(!showReset);
        xAxis === null || xAxis === void 0 ? void 0 : xAxis.removePlotBand('mask-before');
        xAxis === null || xAxis === void 0 ? void 0 : xAxis.removePlotBand('mask-after');
    } }, "Reset Zoom"));
//# sourceMappingURL=ResetZoomButton.js.map